import * as React from 'react';
import { useApiUrl } from '../../../../../../shared/hooks/useApiUrl';
import { ThumbnailModal } from '../../shared/view/ThumbnailModal';

type CustomerImageProps = {
    id: number;
    filename: string;
    imageReference: string;
    highResolutionReference: string;
    onClick?: (event: React.MouseEvent<HTMLDivElement>, id: number) => void;
};

export function CustomerImage({
    id,
    filename,
    onClick,
    imageReference,
    highResolutionReference
}: CustomerImageProps) {
    let apiUrl = useApiUrl();
    let [showThumbnailModal, setShowThumbnailModal] = React.useState(false);

    function handleCloseThumbnailModal() {
        setShowThumbnailModal(false);
    }

    function handleClickThumbnail(event: React.MouseEvent<HTMLDivElement>) {
        if (!event.ctrlKey) {
            setShowThumbnailModal(true);
        }

        if (typeof onClick === 'function') {
            onClick(event, id);
        }
    }

    return (
        <>
            <div className="thumbnail thumbnail-custom">
                <div>
                    <div className="action-icons"></div>
                    <div>
                        <div
                            role="button"
                            className="img-button"
                            aria-label={filename}
                            title={filename}
                            onClick={handleClickThumbnail}
                        >
                            <img
                                className="img-responsive"
                                alt="Digitally styled image"
                                draggable={false}
                                src={`${apiUrl}/file/${imageReference}`}
                            />
                            <span className="img-label">
                                <span className="label-truncate">
                                    {filename ? filename.slice(0, -7) : ''}
                                </span>
                                <span>{filename ? filename.slice(-7) : ''}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <ThumbnailModal
                isOpen={showThumbnailModal}
                imgUrl={`${apiUrl}/file/${highResolutionReference}`}
                onClose={handleCloseThumbnailModal}
                filename={filename}
                fullScale={false}
            />
        </>
    );
}
